import { toRef, watch } from 'vue';
import type {AsyncData} from '#app';
import type {SeoFallback} from '~/interfaces/seo';
import { useEtherSeo } from '~/composables/useEtherSeo';
import { usePageStore } from '~/store/pageStore';

type usePageQueryOpts = {
    // applySeo?: boolean;
    entryKey?: string;
    activeSite?: any;
} & SeoFallback;

const defaultOpts = {
    // applySeo: true,
    entryKey: undefined,
    activeSite: undefined,
} as usePageQueryOpts;


// Generic implementation of useLazyAsyncQuery & useCraftPage
const usePageQuery = (
    response: AsyncData<any, any>,
    opts: Partial<usePageQueryOpts> = defaultOpts,
) => {
    const pageStore = usePageStore();
    const craftEntry = useEtherPage(response, opts.entryKey);

    watch(craftEntry, () => {
        useEtherSeo(craftEntry.value, opts, opts?.activeSite);
        pageStore.setHideLanguageSelection(craftEntry.value?.hideLanguageSelection);
        pageStore.setCraftEntryId(craftEntry.value?.id);
    }, { immediate: true });

    // Extract potential parts
    const headerImage = computed(() => toValue(craftEntry)?.headerImage?.[0]);

    return {
        craftEntry,
        entryCount: toValue(response?.data)?.entryCount,
        pending: toRef(response, 'pending'),
        error: toRef(response, 'error'),
        headerImage,
    };
};

export default usePageQuery;
